export default "__VITE_ASSET__eXBjiHNQ__"